import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-pedido-app',
  templateUrl: './info-pedido-app.component.html',
  styleUrls: ['./info-pedido-app.component.scss']
})
export class InfoPedidoAppComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  openBox(): void {
  	console.log("abrir box");
  }

}
